import { v4 as uuidv4 } from 'uuid';

export const uuid = uuidv4()

export const baseImgUrl = "https://storage.googleapis.com/acreweb.appspot.com/"

export const recaptchaSiteKey = "6LdQKOwZAAAAAPGd4QnuWH4Tkedb2vNuhCyjZDk4"